import routes from '@/modules/response-templates/response-templates-routes';
import store from '@/modules/response-templates/response-templates-store';

export default {
    routes,
    store,
}
